import {
  type FieldPath,
  type PathValue,
  useController,
  useWatch,
} from 'react-hook-form';

import { type BuildQuizListItem } from '../../type';
import { useQuizControl } from '../QuizControlProvider';

type QuizFormField = FieldPath<BuildQuizListItem>;

// selector 기반으로 필드 값을 관리/업데이트 하는 form hook
export const useQuizFormField = <T extends QuizFormField>({
  field,
}: {
  field: T extends QuizFormField ? T : never;
}) => {
  const { index, control } = useQuizControl();
  const value = useWatch({
    control,
    name: `quizList.${index}.${field}`,
  });

  const { field: fieldController } = useController({
    control,
    name: `quizList.${index}.${field}`,
  });

  const update = (value: PathValue<BuildQuizListItem, T>) => {
    fieldController.onChange(value);
  };

  return [value, update] as const;
};
